import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formValueSelector, clearFields } from 'redux-form'
import { accountViewBalance } from 'src/store/account'
import CCYField from '../shared/CCYField'
import { AppDispatch } from 'src/store/index.d'
import { CreditAccountCCYFieldProps } from './ConvertOnAccountInCash.types'

const CreditAccountCCYField: FC<CreditAccountCCYFieldProps> = (props) => {
  const { form, CCY, change, CashAccounts, inCash } = props
  const dispatch = useDispatch<AppDispatch>()

  const filteredCCY = useSelector((state) =>
    CCY.filter((curr) => curr.ID !== formValueSelector(form)(state, 'debitCCY')),
  )

  return (
    <CCYField
      name="creditCCY"
      credit
      onChange={(value: string) => {
        if (inCash) {
          const accountInfo = CashAccounts ? CashAccounts.find((acc) => acc.CCY === value) : undefined

          if (!accountInfo) {
            dispatch(
              clearFields(
                form,
                false,
                false,
                'CreditAccNo',
                'CreditTitleUNI',
                'CreditAccID',
                'CreditAccHash',
                'CreditAccBalance',
                'CreditChosenAccNo',
              ),
            )

            change('CreditAccNo', '')
          } else {
            const { AccountID, HashSum_AccountID_ } = accountInfo
            Promise.resolve(
              dispatch(
                accountViewBalance({
                  AccountID,
                  HashSum_AccountID_,
                }),
              ),
            ).then(({ payload: { Balance } }) => {
              change('CreditAccNo', accountInfo.AccNo)
              change('CreditTitleUNI', accountInfo.TitleUNI)
              change('CreditAccID', AccountID)
              change('CreditAccHash', HashSum_AccountID_)
              change('CreditAccBalance', Balance)
              change('CreditChosenAccNo', accountInfo.AccNo)
            })
          }
        } else {
          dispatch(
            clearFields(
              form,
              false,
              false,
              'CreditAccNo',
              'CreditTitleUNI',
              'CreditAccID',
              'CreditAccHash',
              'CreditAccBalance',
              'CreditChosenAccNo',
            ),
          )
          change('CreditAccNo', '')
          change('CreditTitleUNI', '')
          change('CreditAccID', '')
          change('CreditAccHash', '')
          change('CreditAccBalance', 0)
          change('CreditChosenAccNo', '')
        }
      }}
      FormName={form}
      //@ts-ignore
      ccy={filteredCCY}
    />
  )
}

export default CreditAccountCCYField
